import { LANGUAGE_CODES } from "../constants/language-constants";

const fetchCountries = async () => {
    try {
      const response = await fetch('/data/countries.json');
      if (!response.ok) {
        throw new Error('Failed to fetch countries data');
      }
      const countries = await response.json();
      return countries;
    } catch (error) {
      return [];
    }
};

const fetchCountriesForPhone = async () => {
    try {
      const response = await fetch('/data/countries-phone-numbers.json');
      if (!response.ok) {
        throw new Error('Failed to fetch countries data');
      }
      const countries = await response.json();
      return countries;
    } catch (error) {
      return [];
    }
};

export const getCountryName = async () => {
    const map = {};
    fetchCountries().then(countries => {
        countries.forEach(country => {
            if (country.name?.common) {
                map[country.name.common.toLowerCase()] = country.cca2;
            }
            if (country.name?.official) {
                map[country.name.official.toLowerCase()] = country.cca2;
            }
            if (Array.isArray(country.altSpellings)) {
                country.altSpellings.forEach(alt => {
                    map[alt.toLowerCase()] = country.cca2;
                });
            }
            if (country.demonyms && country.demonyms.eng) {
                if (country.demonyms.eng.f) {
                    map[country.demonyms.eng.f.toLowerCase()] = country.cca2;
                }
                if (country.demonyms.eng.m) {
                    map[country.demonyms.eng.m.toLowerCase()] = country.cca2;
                }
            }
            if (country.languages && typeof country.languages === 'object') {
                Object.values(country.languages).forEach(lang => {
                    if (typeof lang === 'string') {
                        map[lang.toLowerCase()] = country.cca2;
                    }
                });
            }
        });
    });
    return map;
};

export const getCountryWithPhoneCode = async (defaultCountry) => {
    const map = [];

    await fetchCountriesForPhone().then(countries => {
        countries.forEach(country => {
            let phoneCode = null;
            if (country.idd.root) {
                phoneCode = country.idd.root;
                if (country.idd.suffixes && country.idd.suffixes.length === 1) {
                    phoneCode += country.idd.suffixes[0];
                }
                if (phoneCode.length > 5) {
                    phoneCode = null;
                    if ((defaultCountry && defaultCountry === country.cca2) || LANGUAGE_CODES.ENGLISH === country.cca2) {
                        phoneCode = country.idd.root;
                    }
                }
            }

            if (phoneCode !== null) {
                map.push({
                    name: country.name.common,
                    code: country.cca2,
                    phoneCode: phoneCode,
                    isDefault: defaultCountry ? defaultCountry === country.cca2 : LANGUAGE_CODES.ENGLISH === country.cca2
                });
            }
        });
    });
    return map;
}